module.exports = __webpack_public_path__ + "static/assets/0549584f1dd7057c258ac4032a97dd78.png";